import { render } from "./bet.vue?vue&type=template&id=deacb542"
import script from "./bet.vue?vue&type=script&lang=js"
export * from "./bet.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__